<template>
  <v-card min-height="400px">
    <v-data-table
      id="Sanciones"
      class="elevation-1"
      fixed-header
      height="80vh"
      :headers="headers"
      :items="personal"
      :loading="tableLoading"
      loading-text="Cargando reporte de sanciones... Espere..."
      hide-default-footer
      disable-pagination
      no-data-text="No hay personal aún..."
      single-expand
      :expanded.sync="expanded"
      show-expand
      :search="searchPerson"
      item-key="uniqueKey"
      no-results-text="No se encontraron registros..."
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-toolbar-title class="top-bar-title">Sanciones</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchPerson"
            append-icon="mdi-magnify"
            label="Buscar persona..."
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <!-- More info about {{ item.descansos_medicos }} -->
          <v-container fluid>
            <v-data-table
              id="Sanciones-Detalle"
              :headers="sancionesHeaders"
              :items="item.sanciones"
              hide-default-footer
              disable-pagination
              :search="search"
              no-data-text="No hay sanciones/amonestaciones registradas..."
              @click:row="editarSanciones"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title class="top-bar-title"
                    >Registros de {{ item.nombre }}</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn @click="agregarSancion" v-on="on">
                        <v-icon color="teal">mdi-book-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Agregar sanción/amonestación</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar sanciones..."
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
            </v-data-table>
          </v-container>
        </td>
      </template>
    </v-data-table>

    <EditarSanciones
      :persona="this.persona"
      :sancion="this.sancion"
      :nuevaSancion="this.nuevaSancion"
    />
  </v-card>
</template>

<script>
import { mapState } from 'vuex';

import { getPersons } from '@/api/persons/getPersons.js';
import EditarSanciones from './EditarSanciones.vue';
import routeToLoginIfTokenIsExpired from '@/utils/routeToLoginIfTokenIsExpired.js';

export default {
  name: 'Sanciones',
  data: () => ({
    nuevaSancion: true,
    tableLoading: true,
    expanded: [],
    personal: [],
    persona: {},
    sancion: {},
    search: '',
    searchPerson: '',
  }),
  components: {
    EditarSanciones,
  },
  computed: {
    ...mapState(['editarSancionesDialog']),
    sancionesHeaders() {
      let fixedHeaders = [
        {
          text: 'Tipo de sanción/amonestación',
          value: 'tipo_sancion',
        },
        {
          text: 'Gravedad de la falta',
          value: 'gravedad_falta',
        },
        {
          text: 'Fecha de inicio',
          value: 'fecha_inicio',
        },
        {
          text: 'Fecha de fin',
          value: 'fecha_fin',
        },
        {
          text: 'Hechos',
          value: 'hechos',
          width: '300px',
        },
      ];
      return fixedHeaders;
    },
    headers() {
      let fixedHeaders = [
        {
          text: 'Documento',
          value: 'doi',
        },
        {
          text: 'Nombre/Razón social',
          value: 'nombre',
          width: '275px',
        },
        {
          text: 'Cargo',
          value: 'datos_laborales.cargo',
        },
        {
          text: 'Dirección',
          value: 'direccion',
        },
        {
          text: 'Situación laboral',
          value: 'datos_laborales.situacion',
        },
      ];
      return fixedHeaders;
    },
  },
  watch: {
    expanded() {
      this.$store.state.tablaActivaGestionPersonal = 'Sanciones';
      if (this.expanded.length > 0)
        this.$store.state.tablaActivaGestionPersonal = 'Sanciones-Detalle';
    },
    editarSancionesDialog() {
      if (!this.editarSancionesDialog) this.getPersonal();
    },
  },
  created() {
    this.getPersonal();
    this.$store.state.tablaActivaGestionPersonal = 'Sanciones';
  },
  methods: {
    async getPersonal() {
      const { error, personal, tokenExpired } = await getPersons();
      if (error) {
        // console.error('error en el created', error);
      }
      if (personal) {
        this.personal = personal;
        this.personal = this.personal.map((persona) => {
          persona.uniqueKey =
            persona.doi +
            '-sanciones-' +
            persona.datos_laborales.fecha_ingreso +
            persona.datos_laborales.situacion;
          persona.nombre = `${persona.datos_laborales.apellido_paterno} ${persona.datos_laborales.apellido_materno}, ${persona.nombre}`;
          return persona;
        });
        this.personal = this.personal.filter(
          (persona) => persona.datos_laborales.situacion === 'Activo'
        );
        this.tableLoading = false;
      }
      if (tokenExpired) {
        routeToLoginIfTokenIsExpired(this);
      }
    },
    editarSanciones(sancion) {
      this.nuevaSancion = false;
      this.persona = this.expanded[0];
      this.sancion = sancion;
      this.$store.state.editarSancionesDialog = true;
    },
    agregarSancion() {
      this.nuevaSancion = true;
      this.persona = this.expanded[0];
      this.sancion = {
        hechos: '',
        tipo_sancion: '',
        gravedad_falta: '',
        fecha_inicio: '',
        fecha_fin: '',
        texto_sancion: {
          parrafo1: '',
          parrafo2: '',
          parrafo3: '',
        },
      };
      this.$store.state.editarSancionesDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.column-header {
  font-size: 15px !important;
  font-weight: bold !important;
  color: teal !important;
}
.top-bar-title {
  font-size: 25px !important;
  font-weight: bold !important;
  color: teal !important;
}
.v-data-table::v-deep th {
  font-size: 15px !important;
  font-weight: bold !important;
  color: teal !important;
  .v-icon {
    display: none !important;
  }
}
.align-header {
  text-align: center !important;
  background-color: $white;
}
</style>
